import React, { Component } from 'react';
import nuyir from './assets/nuyir.png';
import './App.css';
import Auth from '@aws-amplify/auth';
import Amplify, { Storage, API } from 'aws-amplify';
import Analytics from '@aws-amplify/analytics';
import { Authenticator, SignIn, withAuthenticator} from 'aws-amplify-react';
//withAuthenticator } from 'aws-amplify-react';
import awsconfig from './aws-exports';
import { Switch, Route } from 'react-router-dom';
import Home from './containers/Home.js';
import Profile from './containers/Profile.js';
import Practice from './containers/Practice.js';
import PracticeFrench from './containers/PracticeFrench.js';
import QuizOptions from './containers/QuizOptions.js';

// retrieve temporary AWS credentials and sign requests
Auth.configure(awsconfig);
Amplify.configure(awsconfig);
// send analytics events to Amazon Pinpoint
Analytics.configure(awsconfig);

let loggedInUser = false;
class App extends Component {
  constructor(props) {
    super(props);
    //this.handleAnalyticsClick = this.handleAnalyticsClick.bind(this);
    this.state = {
      //analyticsEventSent: false, resultHtml: "", eventsSent: 0
    };
  }

  // handleAnalyticsClick() {
  //   Analytics.record('AWS Amplify Tutorial Event')
  //     .then( (evt) => {
  //       const url = 'https://console.aws.amazon.com/pinpoint/home/?region=us-east-1#/apps/'
  //         +awsconfig.aws_mobile_analytics_app_id+'/analytics/events';
  //       let result = (<div>
  //         <p>Event Submitted.</p>
  //         <p>Events sent: {++this.state.eventsSent}</p>
  //         <a href={url} target="_blank">View Events on the Amazon Pinpoint Console</a>
  //       </div>);
  //       this.setState({
  //         'analyticsEventSent': true,
  //         'resultHtml': result
  //       });
  //     });
  // }

  get = async () => {
    console.log('calling api');
    const response = await API.get('termapi', '/terms/object/1');
    console.log(JSON.stringify(response, null, 2));
    return response;
  }

  get_new = (number) => {
    return API.get('termapi', '/terms/object/' + number);
  }

  list = async () => {
    console.log('calling api');
    const response = await API.get('termapi', '/terms', {
        'queryStringParameters': {
          'order': 'byTerm'
        }
    } );
    alert(JSON.stringify(response, null, 2));
  }

  render() {
    return (

      <div className="App">
        {/*<button onClick={this.list}>???</button>*/}
        <img className="nuyir" alt="Our Mascot Nuyir!" src={nuyir} />
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route path='/profile' component={Profile}/>
          <Route path='/choose-mode' component={QuizOptions}/>
          <Route path='/practice'
            render={(props) => <Practice {...props} apiget={this.get_new} />}/>
            <Route path='/practice-french'
              render={(props) => <PracticeFrench {...props} apiget={this.get_new} />}/>
        </Switch>
        {/*<div className="App-intro">
          <button className="App-button" onClick={this.handleAnalyticsClick}>Analytics Event</button>
          {this.state.analyticsEventSent}
          <div>{this.state.resultHtml}</div>
        </div>*/}
      </div>
    );
  }
}

export default withAuthenticator(App);
